import React from 'react';
import { BsIcon } from '@hotelplan/core.basis.bs-icon';

interface IBookmarkIconPros {
  onClick(): void;
}

const FdrBookmarkEditIcon: React.FC<IBookmarkIconPros> = ({ onClick }) => {
  return (
    <button
      className={'wishlist-icon-button'}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
    >
      <BsIcon name="bookmark-edit" className="wishlist-icon" />
    </button>
  );
};

export default FdrBookmarkEditIcon;
